export const objectToQueryString = (obj: any): string => {
  const parts = [];

  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      const value = Array.isArray(obj[key]) ? obj[key].join(",") : obj[key];

      parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  }

  return parts.join("&");
};

export const objectToQueryStringWithArray = (obj: any): string => {
  const params = new URLSearchParams();

  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      if (Array.isArray(obj[key])) {
        for (const val of obj[key]) {
          // Agrega múltiples valores
          params.append(key, val);
        }
      } else {
        params.append(key, obj[key]);
      }
    }
  }

  return params.toString();
};

export const normalize = (str: string) => str.trim().toLowerCase();

export const isEmpty = (val: any) =>
  !val || (Array.isArray(val) ? val?.length === 0 : val === "");

export const formatCurrencyInputToNumber = (el: string | number): number => {
  if (typeof el === "number") return el;
  if (!el || typeof el !== "string") return 0;

  const clean = el.replaceAll(/[^\d.,-]/g, "");

  const lastDot = clean.lastIndexOf(".");
  const lastComma = clean.lastIndexOf(",");

  let normalized: string;

  if (lastComma > lastDot) {
    // caso "12.345,67" → coma como decimal
    normalized = clean.replaceAll(".", "").replace(",", ".");
  } else if (lastDot > lastComma) {
    // caso "12,345.67" o "12345.67" → punto como decimal
    normalized = clean.replaceAll(",", "");
  } else {
    // sin separadores → usar tal cual
    normalized = clean;
  }

  const num = Number(normalized);
  return Number.isNaN(num) ? 0 : Number(num.toFixed(2));
};
